import { getStatusBgColor, getStatusTextColor } from '@/pages/oms/orders/utils/statusColor';

/** CS vocabulary uses the familiar palette, but never derives state from WooCommerce. */
export const CsStatusBadge = ({ status }: { status: string }) => {
  const paletteKey =
    status === 'delivered' ? 'completed' : status === 'canceled' ? 'cancelled' : status.replace(/-/g, '_');
  return (
    <span
      className="d-inline-block rounded px-2"
      style={{ color: getStatusTextColor(paletteKey), backgroundColor: getStatusBgColor(paletteKey) }}
    >
      {status}
    </span>
  );
};
